import React from "react";

export default function ErrorTest() {
    throw new Error("Test error");
    // eslint-disable-next-line no-unreachable
    return <div>Should not render</div>;
}
